
interface LoaderProps {
    className?:string;
}

const Loader = (props: LoaderProps):JSX.Element  => {
    const styles = `
        @keyframes spin {
            0% { transform: rotateZ(0deg); }
            100% { transform: rotateZ(360deg); }
        }
        `;
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return <>
        <div className={`flex flex-col justify-center items-center h-full w-full relative bg-opacity-80 animate-pulse text-[18px] ${props?.className}`} >
          <div className={`spinner !w-[50px]  border-[5px] !h-[50px] border-l-gray-500 border-t-[5px] border-t-[blue] rounded-[50%]`} style={{ animation: 'spin 1s linear infinite' }}>
          </div>
           Loading...
        </div>
    </>

};


export default Loader;
